import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch } from "../app/hooks";
import { IActiveProjectTab, setActiveProjectTabInRedux } from "../globalSlice";

export const useHydrateProjectTabFromUrl = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname; // t.ex. "/10216575/design"

    // Matchar: /<projectNo>/<projectTab>
    // Grupper:
    //   1: projectNo (vi bryr oss inte om den här här)
    //   2: projectTab (t.ex. "design")
    const match = path.match(/^\/[^/]+\/([^/]+)/);

    if (!match || !match[1]) {
      return;
    }

    const tabKey = match[1].toLowerCase() as IActiveProjectTab;

    dispatch(setActiveProjectTabInRedux(tabKey));
  }, [dispatch, location.pathname]);
};
